<template>
  <div id="app">
    <header>
      <!-- 导航栏 -->
      <img class="cover" src="./assets/pc/nav.gif" v-if="isPc" @click="clickPcNav">
      <img class="cover" src="./assets/wap/nav.jpg" v-else @click="show=!show">
    </header>
    <main>
      <router-view/>
    </main>
    <footer @click="clickFooter">
      <img class="cover" src="./assets/pc/footer.jpg" v-if="isPc">
      <img class="cover" src="./assets/wap/footer.jpg" v-else>
    </footer>
    <div>
      <a href="https://www.miit.gov.cn/">
        <img class="cover" src="./assets/pc/copyright.jpg" v-if="isPc">
        <img class="cover" src="./assets/wap/copyright.jpg" v-else>
      </a>
    </div>
    <!-- 移动端侧边栏 -->
    <van-popup v-model="show" position="right" :style="{ width:'45%',height: '100%' }">
      <div class="wap-nav" @click="clickWapNav">
        <div class="wap-nav-header">
          <van-icon name="cross" color="#999" @click="show=false"/>
        </div>
        <div class="wap-nav-content">
          <div class="wap-nav-item">首页</div>
          <div class="wap-nav-item">关于我们</div>
          <div class="wap-nav-item">我们的服务</div>
          <div class="wap-nav-item">联系我们</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
export default {
  name: 'App',
  data() {
    return {
      show: false
    }
  },
  computed: {
    isPc() {
      return this.$store.getters.isPc
    },
    isHome() {
      return this.$route.name === 'Home'
    }
  },
  methods: {
    clickPcNav() {
      if (this.isHome) {
        this.$router.push('about')
        return
      }
      this.$router.push('/')
    },
    clickWapNav() {
      if (this.isHome) {
        this.$router.push('about')
      } else {
        this.$router.push('/')
      }
      this.show = false


    },
    clickFooter() {
      if (this.isHome) {
        this.$router.push('about')
        return
      }
    }
  },
  mounted() {
    window.onresize = () => this.$store.commit('CHANGE_WIDTH', document.body.clientWidth)
  }
}
</script>
<style>
body {
  margin: 0;
  padding: 0;
}

img {
  display: block;
}

.cover {
  width: 100%;
}

.wap-nav {
  padding: 0 10px;
}

.wap-nav-header {
  display: flex;
  flex-direction: row-reverse;
  padding: 10px 0;
  border-bottom: 1px solid #eee;
}

.wap-nav-item {
  font-size: 14px;
  color: #999;
  margin: 16px 0;
  cursor: pointer;
}

.wap-nav-item:first-child {
  color: #333;
}
</style>

